export default "__VITE_ASSET__DForpuo3__"